export default __webpack_public_path__ + "static/media/bol_scan_5.9223d35c.svg";